<template>
  <div class="weblink-table-display">
    <v-row class="hidden-sm-and-down ml-0">
      <v-col cols="12" md="5" caption>
        <strong>Title</strong>
      </v-col>
      <v-col cols="12" md="5">
        <strong>Description</strong>
      </v-col>
      <v-col cols="12" md="2">
        <strong>Actions</strong>
      </v-col>
    </v-row>

    <v-row
      v-for="(weblink, index) in weblinks"
      :key="index"
      class="ml-0"
      :class="index !== weblinks.length - 1 && 'weblink-table-display__divider'"
    >
      <v-col cols="12" md="5">
        <div class="hidden-md-and-up mb-1">
          <strong>Title</strong>
        </div>
        <v-row no-gutters>
          <img
            src="~/static/images/Weblink.svg"
            class="weblink-table-display__weblink-icon"
            alt=""
          />
          <v-col class="pa-0 pl-2">
            {{ weblink.title }}
          </v-col>
        </v-row>
      </v-col>

      <v-col cols="12" md="5">
        <div class="hidden-md-and-up mb-1">
          <strong>Description</strong>
        </div>
        <div>{{ weblink.description }}</div>
      </v-col>

      <v-col cols="12" md="2">
        <div class="hidden-md-and-up mb-1">
          <strong>Actions</strong>
        </div>
        <a
          :href="targetUrl(weblink)"
          :aria-label="weblinkAriaLabel(weblink)"
          target="_blank"
          rel="noopener"
          class="primary--text"
        >
          <strong>View</strong>
          <v-icon small color="primary" aria-hidden="true">{{
            mdiOpenInNew
          }}</v-icon>
        </a>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { mdiOpenInNew } from "@mdi/js";

const matchHTTP = /^(http:|https:)\/\/?[a-z0-9]/;

export default {
  name: "WeblinkTableDisplay",
  props: {
    weblinks: { type: Array, default: undefined },
  },
  data() {
    return {
      // Icons
      mdiOpenInNew,
    };
  },
  methods: {
    targetUrl(weblink) {
      const target = weblink.url;

      if (target.match(matchHTTP) === null) {
        return "http://" + target;
      }

      return target;
    },
    weblinkAriaLabel(weblink) {
      return `View ${weblink.title} weblink. [opens in a new tab]`;
    },
  },
};
</script>

<style lang="scss" scoped>
.weblink-table-display {
  &__weblink-icon {
    height: 26px;
    width: 22px;
  }

  @media only screen and (max-width: 959px) {
    &__divider {
      border-bottom: solid 2px var(--v-softened-base);
    }
  }
}
</style>
